const loadDeploys = ({ commit }, payload) => {
    commit('LOAD_DEPLOYS', payload);
};

export default {
    loadDeploys,
};
